import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "../assets/images/logofatoora.svg";


import swal from "sweetalert";
import { CheckAuth, LoginAPI, issueToken } from "../../redux/services/BasicAPIFunctions";
import Spinner from "../Layouts/Spinner";


export default function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    setLoading(true);

    const data = {
      email_id: values.email,
      password: values.password,
    };

    try {
      const res = await CheckAuth(data);
      if (res?.data?.access_token) {
        const accessToken = res.data.access_token;
        localStorage.setItem("authcheck", accessToken);
        loginAndGetAccess(values);
      } else {
        setLoading(false);
        throw new Error("Invalid authentication response");
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      swal({
        text: error.message || "An error occurred",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  };

 

const loginAndGetAccess = async (values) => {
  try {
    const data = {
      email_id: values.email,
      password: values.password,
    };

    const response = await LoginAPI(data);

    if (response?.data?.status) {
      const uuid = response.data.response.uuid;
      const permission = response.data.response.permission;
      const profile = JSON.stringify(response.data.response.profile);

      const Tokenissue = await issueToken({ uuid });
      const expire_accessToken = Tokenissue.data.response.access_token;
      const refresh_token = Tokenissue.data.response.refresh_token;

      localStorage.setItem("token", expire_accessToken);
      localStorage.setItem("refresh", refresh_token);
      localStorage.setItem("permission", JSON.stringify(permission));
      localStorage.setItem("profile", profile);
      setLoading(false);
      navigate("/dashboard");
      swal({
        text: "Login successful",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
    } else {
       setLoading(false);
      swal({
        text: response?.data?.message || "Login failed",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (error) {
     setLoading(false);
    swal({
      text: error.message || "An unexpected error occurred",
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  }
};


  return (
    <div className="login-sec dashboard-padding d-flex justify-content-center align-items-center">
      <div className="login-container col-md-5 mx-auto">
        <img className="login-logo" src={logo} alt="" />
        <h2 className="text-center">Login</h2>
        <form onSubmit={formik.handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              className="form-control"
              placeholder="Enter Email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="error">{formik.errors.email}</div>
            ) : null}
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              className="form-control"
              placeholder="Enter Password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
            />
            {formik.touched.password && formik.errors.password ? (
              <div className="error">{formik.errors.password}</div>
            ) : null}
          </div>
          <div className="login-btn">
            <button
              type="submit"
              disabled={loading}
              className="background-button"
            >
             {loading ?<Spinner/>: <span>Login</span>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
